import React from 'react';
import { Download, FileText } from 'lucide-react';

const PDF_URL = "/capability-statement.pdf";

export default function CapabilityStatement() {
  return (
    <section className="relative py-16 px-5 sm:px-6 overflow-hidden">
      <div className="absolute inset-0" style={{ background: 'linear-gradient(160deg, #09090f 0%, #0b0d16 50%, #09090f 100%)' }} />
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse 70% 60% at center, rgba(37,99,235,0.07) 0%, transparent 65%)' }} />
      <div className="absolute top-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(59,130,246,0.15), transparent)' }} />
      <div className="absolute bottom-0 left-0 right-0 h-px" style={{ background: 'linear-gradient(90deg, transparent, rgba(59,130,246,0.1), transparent)' }} />

      <div className="relative max-w-2xl mx-auto text-center">
        {/* Icon */}
        <div className="inline-flex items-center justify-center w-14 h-14 mb-6 rounded-sm"
          style={{ background: 'rgba(37,99,235,0.1)', border: '1px solid rgba(59,130,246,0.25)' }}>
          <FileText className="w-6 h-6 text-[#60a5fa]" />
        </div>

        <p className="text-[#60a5fa] font-bold tracking-[0.25em] uppercase text-xs mb-3">Capability Statement</p>
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-4 leading-snug">
          Built around builders.<br className="hidden sm:block" /> Program-driven. No surprises.
        </h2>
        <p className="text-gray-400 text-base leading-relaxed mb-8 max-w-xl mx-auto">
          Download our capability statement for an overview of our commercial plumbing services, experience, and how we work with builders and project teams across South East Queensland.
        </p>

        <button
          style={{ maxWidth: '320px', width: '100%' }}
          onClick={async () => {
            const res = await fetch(PDF_URL);
            const blob = await res.blob();
            const url = URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'Oliver_Sons_Capability_Statement.pdf';
            a.click();
            URL.revokeObjectURL(url);
          }}
          className="inline-flex items-center gap-3 text-white font-bold text-sm py-4 px-10 rounded-sm transition-all duration-200"
          style={{ background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', boxShadow: '0 6px 20px rgba(37,99,235,0.4)' }}
          onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 10px 28px rgba(37,99,235,0.6)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
          onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 6px 20px rgba(37,99,235,0.4)'; e.currentTarget.style.transform = 'translateY(0)'; }}
        >
          <Download className="w-4 h-4" />
          Download Capability Statement
        </button>

        <p className="text-gray-500 text-xs mt-5">
          Ideal for builders, developers, and head contractors requiring a clear scope overview.
        </p>
      </div>
    </section>
  );
}